/**
 * Online Checkout Utility Functions
 * Separated from inline scripts for better caching and performance
 */

// Update order data with discount codes and line items
window.updateOrderData = function(orderdata) {
  let discountCodes = Array.from(document.querySelectorAll('.cart-discount__codes li'));
  let discountCodesString = discountCodes.map(li => li.getAttribute('data-discount-code')).join(',');
  let discountCodesArray = discountCodesString ? discountCodesString.split(',') : [];

  let uniqueDiscountCodes = [...new Set(discountCodesArray)];

  orderdata.discountCodes = uniqueDiscountCodes;

  orderdata.lineItems = [];
  document.querySelectorAll('.online_checkout_right_inner .checkout_items').forEach(item => {
    let variantId = `gid://shopify/ProductVariant/${item.dataset.variantId}`;
    let quantity = parseInt(item.dataset.qty);

    orderdata.lineItems.push({
      variantId: variantId,
      quantity: quantity
    });
  });

  return orderdata;
};

// Handle failed payment session redirects
document.addEventListener("DOMContentLoaded", async () => {
  const cko_session_id = new URLSearchParams(window.location.search).get("cko-session-id");

  if (cko_session_id) {
    const previousSessionId = sessionStorage.getItem('previousSessionId');

    if (previousSessionId === cko_session_id) {
      return;
    }

    try {
      const res = await fetch(`https://pay.twowombats.com/api/stage/payment/status?cko-session-id=${cko_session_id}`);
      const data = await res.json();
      Swal.fire({
        title: `${data.status}`,
        text: `${data.reason}`,
        icon: 'error',
        confirmButtonText: 'Try Again'
      });
    } catch (error) {
      console.error("Error checking payment", error);
    }

    sessionStorage.setItem('previousSessionId', cko_session_id);
  }
});
